import { normalizeSport } from '~/modules/InstitutionDashboard/Infrastructure/institutionDashboardConfig'

export type TrophyMemoriesFilter = 0 | 1 | 2

export interface TrophyDisciplineFilterOption {
  key: string
  label: string
}

export interface TrophyListFilters {
  organizerId: string | null
  minMemories: TrophyMemoriesFilter
  discipline?: string | null
  position?: string | null
}

export const DEFAULT_TROPHY_MEMORIES_FILTER: TrophyMemoriesFilter = 0

export function buildTrophyListFilters (
  overrides: Partial<TrophyListFilters> = {}
): TrophyListFilters {
  return {
    organizerId: null,
    minMemories: DEFAULT_TROPHY_MEMORIES_FILTER,
    ...overrides,
  }
}

function parseTrophyAttributeFilter (
  value: string | null | undefined
): string | null {
  if (value === null || value === undefined) {
    return null
  }

  const normalizedValue = value.trim()

  return normalizedValue.length > 0 ? normalizedValue : null
}

export function parseTrophyDisciplineFilter (
  value: string | null | undefined
): string | null {
  const parsedValue = parseTrophyAttributeFilter(value)

  if (parsedValue === null) {
    return null
  }

  return normalizeTrophyDisciplineOption(parsedValue)?.key ?? parsedValue
}

export function parseTrophyPositionFilter (
  value: string | null | undefined
): string | null {
  return parseTrophyAttributeFilter(value)
}

export function isTrophyMemoriesFilter (value: number): value is TrophyMemoriesFilter {
  return value === 0 || value === 1 || value === 2
}

export function normalizeTrophyDisciplineOption (
  value: string
): TrophyDisciplineFilterOption | null {
  const normalizedSport = normalizeSport(value)

  if (normalizedSport === null || normalizedSport.key === 'unknown sport') {
    return null
  }

  return normalizedSport
}

export function parseTrophyMemoriesFilter (
  value: string | null | undefined
): TrophyMemoriesFilter | null {
  if (value === null || value === undefined || value.length === 0) {
    return DEFAULT_TROPHY_MEMORIES_FILTER
  }

  const parsedValue = Number.parseInt(value, 10)

  if (!Number.isInteger(parsedValue) || !isTrophyMemoriesFilter(parsedValue)) {
    return null
  }

  return parsedValue
}
